import cls from 'classnames';
import React, { HTMLProps } from 'react';

export default function OverlayComponent({
  children,
  className,
}: React.PropsWithChildren<HTMLProps<HTMLDivElement>>) {
  return (
    <div className={cls('overlay', className)}>
      <div className="overlay__bg" />
      <div className="overlay__content">{children}</div>
    </div>
  );
}
